import styled from 'styled-components'

export const DivContainer = styled.div`
  background-color: #223a5f;
  min-height: 100vh;
  max-height: auto;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
export const CustomButton = styled.button`
  background-color: transparent;
  border: transparent;
  height: 36px;
  width: 100px;
  font-weight: bold;
  border-radius: 5px;
  align-self: flex-end;
  color: #223a5f;
  pointer: cursor;
`
export const Image = styled.img`
  width: 66%;
  align-self: center;
`
